import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import * as styles from './singleImage.module.scss';
import { SanityContentHeroImage, SanityContentSingleImage } from '../../../../../graphql-types';
import { usePageContext } from '../../../../hooks/contexts/usePageContext';
import { Caption } from '../../../../components/2.0version/caption/Caption';

export interface ISingleImageProps {
  hero?: boolean;
  data: SanityContentSingleImage | SanityContentHeroImage;
}

export const SingleImage = ({ data, hero }: ISingleImageProps) => {
  const { lang } = usePageContext();
  const image = getImage(data.imageCaption?.image?.asset?.gatsbyImageData);
  const caption = data?.imageCaption?._rawCaption?.[lang];
  return (
    <div className={`${styles.wrapper} ${hero ? styles.hero : ''}`}>
      {image ? (
        <GatsbyImage image={image} alt={data?.imageCaption?.alt ?? ''} className={styles.image} />
      ) : null}
      {/* <p className={styles.subtitle}>{subtitle}</p> */}
      {caption && <Caption caption={caption} />}
    </div>
  );
};
